import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useKioskConnectivityStatusBarStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    position: 'relative',
    zIndex: 1
  },
  statusBar: {
    position: 'absolute',
    right: 24,
    [theme.breakpoints.down('sm')]: {
      right: 16
    },
    display: 'flex',
    alignItems: 'left',
    backgroundColor: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(3px)',
    borderRadius: '0 0 10px 10px',
    padding: '6px 6px'
  },
  message: {
    marginLeft: '12px',
    marginRight: '12px',
    color: 'white',
    whiteSpace: 'nowrap'
  },
  inactiveIcon: {
    alignItems: 'right'
  }
}));
